(ns frontend.ui.component.lp-portal.card-admin-menu.view
  (:require
   [herb.core :refer [<class]]
   [frontend.ui.component.lp-portal.card-admin-menu.style :as style]
   [reagent.core :as r]))

(defn card-admin-menu
  [props]
  (let [is-open (r/atom false)
        on-outside-click (fn [] (swap! is-open (fn [] false)))]
    (r/create-class
     {:display-name           "card-admin-menu"
      :component-did-mount    (fn [] (.addEventListener js/document.body "click" on-outside-click))
      :component-will-unmount (fn []
                                (.removeEventListener js/document.body "click" on-outside-click))
      :reagent-render         (fn [{:keys [edit-href on-delete white-dots] :as props}]
                                (let [is-open-now @is-open]
                                  [:div
                                   {:class (<class style/container)}
                                   [:i.fas.fa-ellipsis-h
                                    {:class    (<class style/icon)
                                     :on-click (fn [event]
                                                 (.preventDefault event)
                                                 (.stopPropagation event)
                                                 (reset! is-open (not is-open-now)))}]
                                   (when is-open-now
                                     [:div
                                      {:class    (<class style/menu-container)}
                                      (when edit-href
                                        [:a
                                         {:class (<class style/menu-item)
                                          :href  edit-href}
                                         "Edit"])
                                      [:div
                                       {:class    (<class style/menu-item)
                                        :on-click (fn [event]
                                                    (.preventDefault event)
                                                    (.stopPropagation event)
                                                    (on-delete))}
                                       "Delete"]])]))})))
